const initialState = 1;

const fileUploadsPaginationTenantAdminReducer = (state = initialState, action) => {
      switch (action.type) {
            case 'SET_SELECTED_FILE_UPLOADS_TENANT_ADMIN_PAGE':
                  return action.pageNumber;
            case 'LOGOUT_USER':
                  return 1;
            default:
                  break;
      }
      return state;
};
export default fileUploadsPaginationTenantAdminReducer;